import { MyGiftPoints } from "@/components/MyGiftPoints";
import { createDemoUser, isDemoMode } from "@/utils/demoUser";
import { useAuthStore } from "@roman/shared/store/auth.store";
import type { PointWithdrawalType } from "@roman/shared/types/PointWithdrawal";
import type React from "react";

interface WithDrawalPageProps {
  onClick: ({
    selectedMethod,
  }: {
    selectedMethod: PointWithdrawalType;
  }) => void;
}

export type CardContent = {
  id: PointWithdrawalType;
  heading: string;
  footer: string;
  src: string;
  imageSize: { width: string; height: string };
  limit: { lte: string; ste: string };
};

export const WithDrawalPage: React.FC<WithDrawalPageProps> = ({ onClick }) => {
  const user = isDemoMode() ? createDemoUser() : useAuthStore((state) => state.user);
  const points = Number(user?.redeemablePoints || "0");

  return <MyGiftPoints points={points} onClickCard={(cardId) => onClick({ selectedMethod: cardId })} />;
};
